export default __webpack_public_path__ + "aabe2c3c00f2908c7fe44695a7c5810c.png";